export default __webpack_public_path__ + "static/GulfstreamIVSP_1404_ext01_sm-4885cb35a3a28008fdd74361fdde2ac1.jpg";